import React from 'react';

const langToFlag = {
  fr: '🇫🇷',
  en: '🇬🇧',
  de: '🇩🇪',
  es: '🇪🇸',
  it: '🇮🇹',
};

function Flag({ lang }) {
  return langToFlag[lang] || '🏳️';
}

export default Flag;
